import React, { useEffect, useState } from "react"
import * as routes from "../../Router/RoutesURL";
import { useNavigate, useSearchParams } from "react-router-dom";
import AppContainer from "../../components/AppContainer/AppContainer"
import { Tab, Tabs } from "react-bootstrap";
import VideoPodcastsTable from "./VideosPodcasts/VideoPodcasts";
import BlogsArticlesTable from "./BlogsArticles/BlogsArticles";
import { Button } from "reactstrap";
import { getPermissionByAppName } from "../../utils/Helper"
import WhitePlus from "../../assets/images/CommonComponent/WhitePlus.svg"
import "./ContentManagementDashboard.scss"
import AnnouncementTable from "./Announcements/Announcements";
import { tabKeys } from "../../Config/Constant";

const CONTENT_MANAGEMENT_TABS = [
    {
      key: tabKeys.contentManagement.VIDEO_AUDIO,
      title: "Videos & Audios",
      Component: VideoPodcastsTable,
      permissionKey: "Content Management",
    },
    {
      key: tabKeys.contentManagement.ARTICLES,
      title: "Articles",
      Component: BlogsArticlesTable,
      permissionKey: "Content Management",
    },
    {
      key: tabKeys.contentManagement.ANNOUNCEMENT,
      title: tabKeys.contentManagement.ANNOUNCEMENT,
      Component: AnnouncementTable,
      renderOnActive: true, // lazy render
      permissionKey: "Content Management",
    },
  ];

  
const ContentManagementDashboard = (props) => {
    const { history } = props;
    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState("");

    useEffect(() => {
        const tab = searchParams.get("tab");
        if (tab) {
            setActiveTab(tab);
        } else {
            let defaultTab = tabKeys.contentManagement.VIDEO_AUDIO;
            setActiveTab(defaultTab);
        }
    }, [searchParams]);

    const handleClick = () => {
        if (activeTab == tabKeys.contentManagement.VIDEO_AUDIO) {
            navigate(routes.ADD_VIDEO_PODCASTS, { state: { activeTab, selection: "add" } })
        }
        else if (activeTab == tabKeys.contentManagement.ARTICLES) {
            navigate(routes.ADD_BLOG_ARTICLE, { state: { activeTab, selection: "add" } })
        }else{
            navigate(routes.ADD_ANNOUNCEMENT, { state: { activeTab, selection: "add" } })
        }
    };

    const handleTabSelect = (index) => {
        if(index!==activeTab){
            const newParams = new URLSearchParams();
            newParams.set("tab", index);
            setSearchParams(newParams);
            setActiveTab(index);
        }
    };
    return (
        <AppContainer history={history}>
            <div className="event-table content-management-table">
                <div className="ContentTabsContainer">
                    <div className="buttonDiv">
                        {activeTab == tabKeys.contentManagement.VIDEO_AUDIO && getPermissionByAppName("Content Management") === "write" && <Button className="btn btn-primary mt-2 addContent" type="submit" onClick={handleClick}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />Video Or Audio
                        </Button>}
                        {activeTab == tabKeys.contentManagement.ARTICLES && getPermissionByAppName("Content Management") === "write" && <Button className="btn btn-primary mt-2 addContent" type="submit" onClick={handleClick}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />Add Article
                        </Button>}
                        {activeTab == tabKeys.contentManagement.ANNOUNCEMENT && getPermissionByAppName("Content Management") === "write" && <Button className="btn btn-primary mt-2 addContent" type="submit" onClick={handleClick}>
                            <img className="mr-2 mb-1 " src={WhitePlus} alt="" width="14px" height="14px" />Add Announcement
                        </Button>}
                    </div>
                    <Tabs
                        id="controlled-tab-example"
                        className="TabsDiv"
                        activeKey={activeTab}
                        onSelect={handleTabSelect}
                        >
                        {CONTENT_MANAGEMENT_TABS.map(({ key, title, permissionKey, Component, lazy }) => {
                            const permission = getPermissionByAppName(permissionKey);

                            if (permission === "hide") return null;

                            return (
                            <Tab key={key} eventKey={key} title={title}>
                                {!lazy || activeTab === key ? (
                                <Component activeTab={activeTab} permission={permission} />
                                ) : null}
                            </Tab>
                            );
                        })}
                    </Tabs>

                </div>
            </div>
        </AppContainer >
    )
}

export default ContentManagementDashboard
